<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row class="hidden-md-and-down">
        <v-col
          v-for="button in menuforstatus"
          :key="button.nav"
          class="justify-space-around"
        >
          <base-material-card
            v-if="!loading"
            :color="button.color"
            :icon="button.icon"
            inline
            link
            :to="gettopurl(button.nav)"
          >
            <template v-slot:after-heading>
              <div class="display-1 font-weight-light">
                {{ button.text }}
              </div>
            </template>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-transfer-right"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Track packages from {{ sitedetails.idnum }}
              </div>
            </template>

            <v-data-table
              :headers="headers"
              :items="getpostalshipments"
              :single-expand="singleExpand"
              :expanded.sync="expanded_deposits"
              :items-per-page="5"
              :search="searchpackages"
              sort-by="timestamp"
              sort-desc
              expand-icon="mdi-information"
              item-key="timestamp"
              show-expand
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Packages</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="searchpackages"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              {{ sitedetails.idnum }}
                            </v-col>
                            <v-col>
                              <v-data-table
                                v-model="selected"
                                :items="getpostaldeposits"
                                :single-select="singleSelect"
                                item-key="timestamp"
                                show-select
                              >
                                <template v-slot:item.securebagdeposit.DepositAmount="{ item }">
                                  {{ format_amt(item.securebagdeposit.DepositAmount) }}
                                </template>
                              </v-data-table>
                            </v-col>

                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Package Total is <b>{{ totalShipment }}</b>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Shipment Insruance Limit is <b>$5,000.00</b>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Shipping Address Info: {{ sitedetails.address }}, {{ sitedetails.city }} {{ sitedetails.state }} {{ sitedetails.zipcode }}
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Contact: {{ sitedetails.sitecontactname }}, {{ sitedetails.sitecontactnumber }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="savelabel"
                        >
                          Create
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>

              <template v-slot:item.carrier="{ item }">
                USPS
              </template>
              <template v-slot:item.label="{ item }">
                <a
                  :href="getlabelpdfurl(item)"
                  target="_blank"
                >
                  <v-icon color="red">mdi-pdf-box</v-icon><v-icon>mdi-download</v-icon>
                </a>
              </template>
              <template v-slot:item.timestamp="{ item }">
                {{ format_time(item.timestamp) }}
              </template>

              <template v-slot:item.amount="{ item }">
                {{ format_amt(item.securebagdeposit.DepositAmount) }}
              </template>
              <template v-slot:item.bagid="{ item }">
                {{ item.securebagdeposit.BagNumber }}
              </template>
              <template v-slot:item.trackingnumber="{ item }">
                {{ item.tracking_number }}
              </template>
              <template v-slot:item.vaultstatus="{ item }">
                Processing
              </template>
              <template v-slot:no-data>
                Sorry, No info {{ sitedetails.idnum }}
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-card class="my-0">
                    <v-card-text>
                      <base-subheading
                        subheading="Deposit Transit Events"
                      />
                      <base-subheading
                        :subheading="item.trackdata.carrier_status_description"
                      />
                      <base-material-tabs
                        icons-and-text
                        vertical
                        color="warning"
                      >
                        <v-tab
                          v-for="(tab, i) in item.trackdata.events"
                          :key="i"
                        >
                          {{ tab.city_locality }}
                          <v-icon>
                            mdi-map-marker
                          </v-icon>
                        </v-tab>
                        <v-tab-item
                          v-for="(tab, i) in item.trackdata.events"
                          :key="i"
                        >
                          <v-card
                            color="white"
                            class="pa-4 ma-4"
                          >
                            <v-card-title>
                              {{ tab.description }} Occured at: {{ tab.occurred_at }}
                            </v-card-title>
                            <v-card-text>
                              {{ tab.city_locality }} {{ tab.postal_code }} {{ tab.state_province }} {{ tab.country_code }}
                            </v-card-text>
                            <v-card-text>
                              Shipper Event Code: {{ tab.event_code }} Shipper Status Code: {{ tab.status_code }}
                            </v-card-text>
                            <v-card-text>
                              Latitude: {{ tab.latitude }} Longitude: {{ tab.longitude }}
                            </v-card-text>
                            <br>
                          </v-card>
                        </v-tab-item>
                      </base-material-tabs>
                    </v-card-text>
                  </v-card>
                </td>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
        <v-col
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-transfer-right"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Bag Deposits created {{ sitedetails.idnum }}
              </div>
            </template>
            <v-data-table
              :headers="headers_deposits"
              :items="getsecurebagdeposits"
              :items-per-page="5"
              :search="search_deposits"
              sort-by="timestamp"
              sort-desc
              item-key="timestamp"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Deposit Bags</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search_deposits"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                </v-toolbar>
              </template>
              <template v-slot:item.carrier="{ item }">
                USPS
              </template>
              <template v-slot:item.timestamp="{ item }">
                {{ format_time(item.timestamp) }}
              </template>

              <template v-slot:item.amount="{ item }">
                {{ format_amt(item.securebagdeposit.DepositAmount) }}
              </template>
              <template v-slot:item.bagid="{ item }">
                {{ item.securebagdeposit.BagNumber }}
              </template>
              <template v-slot:item.trackingnumber="{ item }">
                {{ item.tracking_number }}
              </template>
              <template v-slot:item.vaultstatus="{ item }">
                Processing
              </template>
              <template v-slot:no-data>
                Sorry, No info {{ sitedetails.idnum }}
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format, zonedTimeToUtc } from 'date-fns-tz'
  const axios = require('axios')
  var numeral = require('numeral')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      dialog: false,
      selected: [],
      expanded_deposits: [],
      expanded_bags: [],
      loading: false,
      searchpackages: '',
      search_deposits: '',
      searchorder: '',
      searchdeposits: '',
      searchbags: '',
      sitedetails: '',
      snackbar: false,
      unit_id: '',
      timeout: 5000,
      singleSelect: false,
      search: '',
      alertmessage: '',
      baglist: [],
      headers: [
        { text: 'Created', align: 'left', value: 'date', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'tracking_number', sortable: true },
        { text: 'Amount', align: 'center', value: 'amt', sortable: true },
        // { text: 'Status', align: 'center', value: 'status', sortable: true },
      ],
      headers_changeorder: [
        { text: 'Ship Date', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'trackingnumber', sortable: true },
        { text: 'Amount', align: 'center', value: 'type', sortable: true },
        { text: 'Status', align: 'center', value: 'status', sortable: true },
      ],
      headers_securitybags: [
        { text: 'Ship Date', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'tracking_number', sortable: true },
        { text: 'Amount', align: 'center', value: 'type', sortable: true },
        { text: 'Status', align: 'center', value: 'status', sortable: true },
      ],
      headers_deposits: [
        { text: 'Date', align: 'left', value: 'date', sortable: true },
        { text: 'Bag ID', align: 'center', value: 'bagid', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'tracking_number', sortable: true },
        { text: 'Shipped', align: 'center', value: 'status', sortable: true },
        { text: 'Deposit Amount', align: 'center', value: 'total', sortable: true },
      ],
      alerts: [],
      depositusers: [],
      expanded: [],
      singleExpand: true,
      editedIndex: -1,
      editedItem: {
        safeid: '',
        bags: [],
        idnum: '',
        timestamp: '',
        allowedusers: '',
        duration: '',
        washifyid: '',
        source: '',
        status: '',
        userid: '',
        amount: '',
      },
      defaultItem: {
        safeid: '',
        idnum: '',
        bags: [],
        timestamp: '',
        duration: '',
        allowedusers: '',
        washifyid: '',
        status: '',
        userid: '',
        amount: '',
        source: '',
      },
    }),

    computed: {
      menuforstatus () {
        if (this.$store.getters.user.status === 'storemanager') {
          return []
        } else if (this.$store.getters.user.status === 'groupmanager') {
          return []
        } else if (this.$store.getters.user.status === 'corporate') {
          return [
            {
              text: 'Create Bags',
              value: 'deposits',
              color: 'pink',
              icon: 'mdi-shopping-outline',
              nav: '/Depositpost/'
            },
            {
              text: 'Ship Package',
              value: 'deposits',
              color: 'blue',
              icon: 'mdi-truck',
              nav: '/Depositshipments/'
            },
          ]
        } else if (this.$store.getters.user.status === 'admin') {
          return [
            {
              text: 'Create Bags',
              value: 'deposits',
              color: 'pink',
              icon: 'mdi-shopping-outline',
              nav: '/Depositpost/'
            },
            {
              text: 'Ship Package',
              value: 'deposits',
              color: 'blue',
              icon: 'mdi-truck',
              nav: '/Depositshipments/'
            },
          ]
        }
      },
      formIsValid () {
        return this.editedItem.email !== '' &&
          this.editedItem.accesscode !== '' &&
          this.editedItem.username !== ''
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Shipment' : 'Edit Label in Transit'
      },
      getpostaldeposits () {
        let securitybags = this.$store.getters.getLoadedPostalDeposits.filter(deposit => deposit.shipped != true)
        return securitybags
      },
      getsecurebagdeposits () {
        let securebags = this.$store.getters.getLoadedSecureBagDeposits
        if (!securebags) {
          return
        }
        securebags.forEach(bag => {
          console.log(bag)
          if (bag.securebagdeposit && bag.securebagdeposit.DepositAmount) {
            Object.assign(bag, { total: numeral(bag.securebagdeposit.DepositAmount).format('$0.00') })
            Object.assign(bag, { date: this.formatForZone(bag.timestamp) })
            Object.assign(bag, { bagid: bag.securebagdeposit.BagNumber })
          }
          if (bag.shipped === true) {
            Object.assign(bag, { status: 'shipped' })
          } else {
            Object.assign(bag, { status: 'not shipped' })
          }
        })
        return securebags
      },
      getchangeorders () {
        let posts = this.$store.getters.getLoadedPostalOrders
        return posts
      },
      getbagorders () {
        let bags = this.$store.getters.getLoadedPostalOrders
        let order = this.$store.getters.getLoadedPostalBags
        return order
      },
      totalShipment () {
        let total = 0
        this.selected.forEach(item => {
          total += parseFloat(item.securebagdeposit.DepositAmount)
        })
        return numeral(total).format('$0.00')
      },
      getsecuritybags () {
        let securitybags = this.$store.getters.getLoadedPostalDeposits
        for (let secbag of securitybags) {
          Object.assign(secbag, { total: numeral(secbag.securebagdeposit.DepositAmount).format('$0.00') })
          Object.assign(secbag, { date: this.formatForZone(secbag.timestamp) })
          Object.assign(secbag, { bagid: secbag.securebagdeposit.BagNumber })
          if (secbag.shipped === true) {
            Object.assign(secbag, { status: 'shipped' })
          } else {
            Object.assign(secbag, { status: 'not shipped' })
          }
        }

        // move amount and bag id to top level, search wont go past the top level in the structure
        return securitybags
      },
      getpostalshipments () {
        let recs = this.$store.getters.getLoadedPostalShipments
        for (let record of recs) {
          let sum = 0
          if (record.contents) {
            record.contents.forEach(item => {
              sum += parseFloat(item.securebagdeposit.DepositAmount)
            })
          }
          if (!record.timestamp) {
            console.log('$$$ 548 ', record)
            record.timestamp = 0
          }
          Object.assign(record, { date: this.formatForZone(record.timestamp) })

          // Object.assign(record, { trackingnumber: record.contents.length })
          // Object.assign(record, { count: record.contents.length })
          Object.assign(record, { amt: numeral(sum).format('$0.00') })
        }
        // get count of the contents
        // get total amount of the bags
        return recs
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
      this.initialize()
    },
    beforeDestroy () {
      this.$store.dispatch('stoprealtimepostalshipments', this.id)
    },
    methods: {
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.loadedPendingDeposits
      },
      formatForZone (timestamp) {
        let timezone = this.sitedetails.timezone
        let sitetimezone
        let output
        let pattern = 'yyyy-MM-dd HH:mm:ss'

        if (timezone === 'EST') {
          sitetimezone = 'America/New_York'
        } else if (timezone === 'CST') {
          sitetimezone = 'America/Chicago'
        } else if (timezone === 'PST') {
          sitetimezone = 'America/Los_Angeles'
        } else if (timezone === 'MST') {
          sitetimezone = 'America/Denver'
        } else if (timezone === 'GMT') {
          sitetimezone = 'Europe/London'
        }
        let zonedTime = utcToZonedTime(timestamp, sitetimezone)
        output = format(zonedTime, pattern, { sitetimezone })
        return output
      },
      gettopurl (nav) {
        let url = nav + this.$route.params.id
        return url
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('YYYY-MM-DD, HH:mm')
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      getlabelpdfurl (data) {
        let url = ''
        if (data.label_download) {
          url = data.label_download.pdf
        }
        return url
      },

      getsitemap (machineid) {
        this.$log.debug('sitemap')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
            }
          }
        }
        console.log(this.sitedetails, machineid)
        this.$store.dispatch('loadsecuritybagdeposits', machineid)
        this.$store.dispatch('loadpostalshipments', machineid)
        this.$store.dispatch('loadpostalorders', machineid)
        this.$store.dispatch('loadpostalbags', machineid)
      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.id
          }
          this.$store.dispatch('removePendingDeposit', rec)
        }
      },
      baglist (machineid) {
        return ['one', 'two']
      },
      close () {
        this.dialog = false
        this.selected = []
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      savelabel () {
        let postaldeposit = { Name: 'Unsent', Amount: '0' } // we dont know whats in the bag yet
        let pickupday = moment().add(1, 'day').format('YYYY-MM-DD')
        let timezone = 'America/New_York'
        let tstart = pickupday + ' ' + '12:00'
        let tend = pickupday + ' ' + '16:00'
        let start = zonedTimeToUtc(tstart, timezone)
        let end = zonedTimeToUtc(tend, timezone)
        let rec = {
          siteid: this.sitedetails.idnum,
          safeid: this.id,
          contents: this.selected,
          used: false,
          postaldeposit: '',
          timestamp: Date.now(),
          pickupstart: start.toISOString(),
          pickupend: end.toISOString(),
          sitedetails: this.sitedetails
        }
        this.editedItem = this.defaultItem // reset values
        this.alertmessage = 'Your deposit has been recorded'
        this.snackbar = true
        this.$store.dispatch('createPostalLabel', rec)
        this.dialog = false
        this.$store.dispatch('loadpostaldeposits', this.id)
        // this.$store.dispatch('loadpostaldeposits', this.$route.params.id)
      },
    },
  }
</script>
